<layout-sidebar>
  <div class="replace-vehicle-review main">
    <ds-error-message [errorList]="errorList"></ds-error-message>
    <div class="row margin-bottom-10">
      <div class="column twelve">
        <p dsContent [contentPath]="'policy.onlineBindFailureInfoText'" class="new-vehicle"></p>
      </div>
    </div>

    <div class="row callToAction">
      <div class="callToAction-row">
        <button
          ds-button
          class="primary-cta -outline"
          type="button"
          [disabled]="!(roleService.isAuthorized('replacevehiclequote_sendtoagent') | async)"
          (click)="submit()"
        >
          Send to my agent
        </button>
      </div>
    </div>
  </div>
</layout-sidebar>
